import { render, staticRenderFns } from "./NlpRightBackground.vue?vue&type=template&id=f64a312e"
import script from "./NlpRightBackground.vue?vue&type=script&lang=js"
export * from "./NlpRightBackground.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports